import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Site-wide strip: every page ends with the same invitation — send us research or a site. */
export const ProposalStrip = () => (
  <section className="border-y border-ochre/25 bg-[#0b0b0b]" data-testid="proposal-strip">
    <div className="mx-auto flex max-w-[1200px] flex-col gap-6 px-5 py-12 md:flex-row md:items-center md:justify-between md:px-10 md:py-14">
      <div className="max-w-2xl">
        <p className="mono text-[0.55rem] uppercase tracking-[0.2em] text-ochre">Open to every county</p>
        <h2 className="mt-3 text-base font-semibold text-white md:text-lg">
          Know a site, a cost or a number we should publish?
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
          Land nobody is using, a school field, a county ground, a real build cost, a grassroots project worth
          following. Send it in and we will add it to the research with a source.
        </p>
      </div>
      <div className="flex shrink-0 flex-wrap gap-3">
        <Link to="/apply" className="btn-primary inline-flex items-center gap-2" data-testid="proposal-strip-apply">
          Send it in <ArrowRight size={14} />
        </Link>
        <Link to="/sources" className="btn-ghost" data-testid="proposal-strip-sources">
          How we source the numbers
        </Link>
      </div>
    </div>
  </section>
);

export default ProposalStrip;
